import { render, staticRenderFns } from "./FeedProductRepairJobTextsTab.vue?vue&type=template&id=aa740ab4&"
import script from "./FeedProductRepairJobTextsTab.vue?vue&type=script&lang=ts&"
export * from "./FeedProductRepairJobTextsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports